// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ribbon[data-v-76407503]{position:absolute;z-index:2;font-size:32px;padding:0 8px 8px;top:-2px;color:#fff;opacity:.3}[dir=ltr] .ribbon--left[data-v-76407503]{left:0}[dir=rtl] .ribbon--left[data-v-76407503]{right:0}.ribbon[data-v-76407503]:hover{opacity:.7;cursor:pointer}", ""]);
// Exports
module.exports = exports;
